module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAUCAYAAABBECfmAAAAAXNSR0IArs4c6QAAAI1JREFUKBXNkLEVgzAMRK1kC1dkB/fAZNEobJKk907OHfHxjArqqJB1d/48rJSGKqX4INNNAsHSWnvylHeEMLybOn9kp2aGoGfRIo/bvIByNuvUi2IsM1vvOecN5jQGnBE+ovffmu98cyvxN/GUDzfkMejajUOkSdVal+vd6pOiRdEXydnZUL732ECfgi8H3jAceO6LHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topDown.png
// module id = 1398
// module chunks = 32